import LayoutContext from 'components/Layout/LayoutContext';
import { ConfirmarPresenca } from 'components/Modal/ConfirmarPresenca';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import Breadcrumb, {
  IBreadCrumbItem,
} from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import AssembleiaDateTime from 'components/__SHARED__/AssembleiaDateTime';
import Page from 'components/__SHARED__/PrivateContainer';
import { ITopBarMenuItem } from 'components/__SHARED__/TopBar/TopBarMenuItem';
import { parseISO } from 'date-fns';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { TopBarMenuAcessoRapido } from 'helpers/enums/TopBarMenuAcessoRapido';
import AxiosErrorHandler from 'helpers/utils/AxiosErrorHandler';
import dotsOnLargeText from 'helpers/utils/dotsOnLargeText';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { getAcessoRapido } from 'helpers/utils/TopBarMenuUtils';
import {
  AssembleiaAssessorRoutePath,
  AssessorRelatoriosRoutePath,
  AssessorRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import UnauthorizedScreen from 'pages/Errors/UnauthorizedScreen/UnauthorizedScreen';
import {
  Button,
  ButtonThemes,
  CheckCircleIcon,
  Col,
  Collapse,
  Row,
  ScreenSize,
  Tabs,
  Title,
} from 'plataforma-fundacao-componentes';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  assembleiasAssessorActionsAtualizarPresencas,
  assembleiasAssessorLoadEvento,
} from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorReducer } from 'store/modules/AssembleiasAssessorReducer';
import { IAuthReducer } from 'store/modules/AuthReducer';
import { closeModal, openModal } from 'store/modules/ModalActions';
import {
  getCurrentWSEvent,
  setCurrentWSEvent,
  wsAssembleiasActionsClose,
  wsAssembleiasActionsOpen,
} from 'store/modules/WSAssembleiasActions';
import { IWSAssembleiasReducer } from 'store/modules/WSAssembleiasReducer';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import Filtros from './Filtros';
import FiltrosConvidados from './FiltrosConvidados';
import {
  relatorioInitialState,
  relatorioInitialState2,
  relatorioReducer,
} from './reducer';
import useStyle from './style';
import Tabela from './Tabela';
import TabelaConvidados from './TabelaConvidados';
import Totais from './Totais';

interface PageParams {
  idAssembleia: string;
}

export default function RelatorioPresentes() {
  const layoutContext = useContext(LayoutContext);
  const classes = useStyle();
  const { idAssembleia } = useParams<PageParams>();
  const [atual, setAtual] = useState<number>(0);
  const { evento, loadingEvento } = useSelector<
    IReducer,
    IAssembleiasAssessorReducer
  >((state) => state.assembleiasAssessor);
  const { opened: wsOpened } = useSelector<IReducer, IWSAssembleiasReducer>(
    (state) => state.wsAssembleias
  );
  const { usuario } = useSelector<IReducer, IAuthReducer>(
    (state) => state.auth
  );
  const { gerandoRelatorio } = useSelector((state: IReducer) => state.assessor);
  const dispatch = useDispatch();
  const [state, action] = useReducer(relatorioReducer, relatorioInitialState);

  const breadcrumbItens = useMemo((): Array<IBreadCrumbItem> => {
    if (!evento) return [];
    return [
      {
        nome: translation.MainRoute.title,
        url: AssessorRoutePath,
      },
      {
        nome: dotsOnLargeText(evento.nome, 30),
        url: AssembleiaAssessorRoutePath.replace(':id', `${evento.id}`),
      },
      {
        nome: translation.RelatorioPresentes.title,
      },
    ];
  }, [evento]);

  const backToEvent = useCallback(() => {
    if (!evento) return;
    history.push(AssembleiaAssessorRoutePath.replace(':id', `${evento.id}`));
  }, [evento]);

  const needLoadEvento = useMemo(() => {
    if (!evento) return true;
    if (evento.id !== parseInt(idAssembleia)) return true;
    return false;
  }, [evento, idAssembleia]);

  const isAGN = useMemo(() => {
    if (!evento?.tipo) return false;
    return [AssembleiaTipo.Nucleo, AssembleiaTipo.Reuniao].includes(
      evento.tipo
    );
  }, [evento]);

  const refresh = useCallback(() => {
    dispatch(
      assembleiasAssessorLoadEvento(
        parseInt(idAssembleia),
        undefined,
        (error) => {
          AxiosErrorHandler(error);
        }
      )
    );
  }, [dispatch, idAssembleia]);

  const atualizarTotais = useCallback(() => {
    action({ type: 'setLoadingTotais', value: true });
    dispatch(
      assembleiasAssessorActionsAtualizarPresencas(
        parseInt(idAssembleia),
        (value) => {
          action({ type: 'setTotais', value });
          action({ type: 'needReload', value: true });
          action({ type: 'setLoadingTotais', value: false });
        },
        (fail) => {
          ErrorHandler(fail);
          action({ type: 'setLoadingTotais', value: false });
        }
      )
    );
  }, [dispatch, idAssembleia]);

  const subMenu = useMemo<ITopBarMenuItem[]>(() => {
    if (!usuario || !evento?.id) return [];
    const menus: ITopBarMenuItem[] = idAssembleia
      ? getAcessoRapido(
          translation,
          usuario.perfil,
          TopBarMenuAcessoRapido.Presentes,
          idAssembleia,
          evento?.tipo
        )
      : [];

    if (evento.id === parseInt(idAssembleia)) {
      menus.push({
        label: translation.SubMenus.relatorio,
        onClick: () =>
          window.open(
            AssessorRelatoriosRoutePath.replace(':id', idAssembleia.toString()),
            '_blank'
          ),
        disabled: false,
      });
    }

    // if (evento.id === parseInt(idAssembleia)) {
    //   menus.push({
    //     label: translation.SubMenus.relatorioConvidados,
    //     onClick: () => gerarRelatorio(false, true),
    //     disabled: gerandoRelatorio,
    //   });
    // }

    return menus;
  }, [usuario, evento, idAssembleia]);

  const modalConfirmPresence = useCallback(() => {
    if (!evento) return;

    const modalKey: string = getUniqueKey();
    dispatch(
      openModal(ConfirmarPresenca, {
        modalKey: modalKey,
        preventEscExit: true,
        preventMaskExit: true,
        mobileOn: ScreenSize.xs,
        eventId: evento.id,
        eventMode: evento.modo,
        title: translation.ConfirmarPresencaModal.title,
        onClose: () => {
          dispatch(closeModal(modalKey));
        },
        onConfirm: () => {
          return new Promise<void>((resolve: any) => {
            atualizarTotais();
            resolve();
            dispatch(closeModal(modalKey));
          });
        },
      })
    );
  }, [dispatch, atualizarTotais, evento]);

  useEffect(() => {
    atualizarTotais();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (needLoadEvento) {
      refresh();
    }
  }, [needLoadEvento, refresh]);

  useEffect(() => {
    if (!evento?.id || !usuario) return;
    if (!wsOpened && evento.id === parseInt(idAssembleia)) {
      dispatch(
        wsAssembleiasActionsOpen(
          usuario.tokenWs!,
          usuario.cpfCnpj!,
          evento.id,
          false,
          evento.status,
          () => setCurrentWSEvent(evento.id)
        )
      );
    }
  }, [evento, usuario, wsOpened, idAssembleia, dispatch]);

  useEffect(() => {
    if (wsOpened && getCurrentWSEvent() !== parseInt(idAssembleia)) {
      dispatch(wsAssembleiasActionsClose());
    }
  }, [wsOpened, idAssembleia, dispatch]);

  useEffect(() => {
    layoutContext.setPageMenuItems(subMenu);
    return () => {
      layoutContext.setPageMenuItems();
    };
    // eslint-disable-next-line
  }, [usuario, subMenu]);

  useEffect(() => {
    action({ type: 'setFiltros', value: relatorioInitialState2 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atual]);

  if (
    !usuario?.perfil.assessorRoute.assembleias.ver ||
    !usuario?.perfil.assessorRoute.assembleias.participantes.verTotal
  ) {
    return <UnauthorizedScreen />;
  }

  if (needLoadEvento) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  return (
    <Page
      headerClassName={classes.header}
      header={
        <React.Fragment>
          <Row>
            <Col style={{ flexDirection: 'column' }}>
              <Title showBackButton onBackClick={backToEvent}>
                {translation.RelatorioPresentes.title}
              </Title>
            </Col>
            <Col>
              <Breadcrumb itens={breadcrumbItens} />
            </Col>
            <Col>
              <AssembleiaDateTime date={parseISO(evento!.dataEvento)} />
            </Col>
          </Row>
          <Row>
            {evento!.modo === AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO &&
            evento!.status === AssembleiaStatus.Live &&
            usuario.perfil.associadoRoute.assembleias.live ? (
              <Col buttonActionsCol end>
                <Button
                  theme={ButtonThemes.Primary}
                  leftIcon={<CheckCircleIcon />}
                  onClick={() => {
                    modalConfirmPresence();
                  }}
                >
                  {translation.BoxConfiguracaoVotos.labelButton}
                </Button>
              </Col>
            ) : undefined}
          </Row>
        </React.Fragment>
      }
      contentClassName={classes.content}
    >
      <Totais
        loading={state.loadingTotais}
        atualizar={atualizarTotais}
        usuariosLoagdos={
          state.totais?.quantidadePessoasOnline !== undefined
            ? state.totais.quantidadePessoasOnline
            : 0
        }
        contasCapital={
          state.totais?.contasCapital !== undefined
            ? state.totais.contasCapital
            : evento!.contasCapital
        }
        presentes={
          state.totais?.presentes !== undefined
            ? state.totais.presentes
            : evento!.presentes
        }
        convidados={
          state.totais?.convidados !== undefined
            ? state.totais.convidados
            : evento!.convidados || 0
        }
        quorumAtingido={
          state.totais?.quorumAtingido !== undefined
            ? state.totais.quorumAtingido
            : evento!.quorumAtingido
        }
        aptos={
          state.totais?.presentesAptos !== undefined
            ? state.totais.presentesAptos
            : evento!.presentesAptos
        }
        isAGN={isAGN}
      />
      <Col style={{ marginTop: '22px' }}>
        <Tabs
          atual={atual}
          onChange={setAtual}
          tabs={[
            { title: 'Associados presentes', id: 'associadosPresentes' },
            { title: 'Convidados presentes', id: 'convidadosPresentes' },
          ]}
        />
      </Col>
      <Collapse opened={atual === 0} animateOpacity>
        <Filtros
          idEvento={evento!.id}
          onChangeFilter={(value) => action({ type: 'setFiltros', value })}
        />
        <Tabela
          idEvento={evento!.id}
          agencias={state.agencias}
          nucleos={state.nucleos}
          cpfOrNome={state.cpfOrNome}
          needReload={state.needReloadTable}
          onReload={() => action({ type: 'needReload', value: false })}
          modalities={evento?.modo}
        />
      </Collapse>
      <Collapse opened={atual === 1} animateOpacity>
        <FiltrosConvidados
          idEvento={evento!.id}
          onChangeFilter={(value) => action({ type: 'setFiltros', value })}
        />
        <TabelaConvidados
          idEvento={evento!.id}
          texto={state.texto}
          needReload={state.needReloadTable}
          onReload={() => action({ type: 'needReload', value: false })}
        />
      </Collapse>
      {(loadingEvento || gerandoRelatorio) && <Loading />}
    </Page>
  );
}
